module.exports = __webpack_public_path__ + "static/img/3.2d0a0a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/3.png
// module id = gXTk
// module chunks = 3